export default __webpack_public_path__ + "static/media/servicetype_sheetmetal.7786f78a.png";